import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { DialogTitle, Grid } from '@mui/material';
import { TextField } from '@mui/material';
import "src/components/deleteAssure.css"


const ProposeFee = ({ open, onClose, setFee, onToggleFee }) => {
    const [value,setValue]=useState("")


    
    return (

        <Dialog open={open} onClose={onClose} >
            <DialogTitle> Insert Maintenance Fee </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                     id="outlined-basic" 
                     placeholder='Fee Amount'
                    fullWidth
                    value={value}
                    onChange = {(e) => {
                        setValue(e.target.value);
                     }}
                />
            </DialogContent>
            <DialogActions>

                <Grid container>
                    <Grid item xs={6} md={6} >
                        <div className='cancel'>
                            <Button
                                onClick={onClose}
                                variant="text">
                                Cancel
                            </Button>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={6} >
                        <div className='addButton'>
                            <Button variant="text"
                                onClick={() => {
                                    setFee(value);
                                    onToggleFee(true);
                                    onClose();
                                  }}> Propose Fee </Button>
                        </div>
                    </Grid>
                </Grid>
            </DialogActions>

        </Dialog>

    );
};

export default ProposeFee;
